import { ChevronRight } from "lucide-react";
import { useSelector } from "react-redux";
import { translations } from "../../../../utils/language";

const PersonalizarModule = ({ title, icon, name, onOpen, isNew }) => {
	const language = useSelector((state) => state.reducerLanguage);
	return (
		<div
			onClick={() => onOpen?.(name)}
			className="flex flex-row h-9 py-1.5 px-2 justify-between items-center rounded-md cursor-pointer select-none hover:bg-gray-100"
		>
			<div className="flex flex-row gap-2 items-center min-w-0">
				{icon}
				<p className="font-semibold text-xs truncate">{title}</p>
				{isNew ? (
					<span className="shrink-0 rounded bg-indigo-50 px-1.5 py-0.5 text-[10px] font-semibold text-indigo-600">
						{translations["thema-badge-novo"][language?.data || "pt"]}
					</span>
				) : null}
			</div>
			<ChevronRight size={18} color="#111827" className="shrink-0" />
		</div>
	);
};

export default PersonalizarModule;
